module.exports = __webpack_public_path__ + "static/img/tu-berlin-logo.7d6b8411.svg";